import {createAction, props} from "@ngrx/store";

export const setIsLoggedIn = createAction("[Auth] Set IsLoggedIn", props<{isLoggedIn: boolean}>());

export const setUserRoles = createAction("[Auth] Set UserRoles", props<{userRoles: Array<string>}>());

export const setIsAdmin = createAction("[Auth] Set IsAdmin", props<{isAdmin: boolean}>());

export const setIsUser = createAction("[Auth] Set IsUser", props<{isUser: boolean}>());

export const setToken = createAction("[Auth] Set Token", props<{token: string}>());
